export default {
  'form.title': 'Listado de Fomrularios',
  'config.searchForm': 'Buscar Formulario',
  'config.form.isInitialForm': '¿Formulario Inicial?',
  'config.form.isHeaderDetailsVisible': '¿Detalles de Cabecera Visible?',
  'config.form.isVisibleInDetails': '¿Visible en Vista Detalles de Solicitud?',
};
